import { useContext, useEffect, useState } from "react";
import { ModuleContext } from "../common/components";
import { UsersBackend } from "./backends";
import { UserModel } from "./models";
import { UserAction } from "./models/Actions";
import { UsersLayout } from "./UsersLayout";
import AppContext from "../../contexts/AppContext";

export function UsersModule() {
  const appContext = useContext(AppContext);
  const moduleContext = useContext(ModuleContext);

  const [allUsers, setAllUsers] = useState<UserModel[]>([]);
  const [selectedUser, setSelectedUser] = useState<UserModel>();

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    const fetchedUsers = await moduleContext?.run(UsersBackend.fetchAllUsers);
    setAllUsers(fetchedUsers);
  }

  async function selectUser(user?: UserModel) {
    if (user) {
      const fetchedUser = await moduleContext?.run(UsersBackend.fetchUser, user.id, appContext.login?.uid);
      setSelectedUser(fetchedUser);
    } else {
      setSelectedUser(undefined);
    }
  }

  async function addUser(user: UserModel) {
    await moduleContext?.run(UsersBackend.createUser, user, appContext.login?.uid);
    await loadUsers();
  }

  async function updateUser(user: UserModel) {
    await moduleContext?.run(UsersBackend.updateUser, user.id, user, appContext.login?.uid);
    await loadUsers();
  }

  async function deleteUser(user: UserModel) {
    await moduleContext?.run(UsersBackend.deleteUser, user.id, appContext.login?.uid);
    await loadUsers();
  }

  async function userActionHandler(action: UserAction, user?: UserModel) {
    if (action === "select") {
      await selectUser(user);
    } else if (action === "add" && user) {
      await addUser(user);
    } else if (action === "update" && user) {
      await updateUser(user);
    } else if (action === "delete" && user) {
      await deleteUser(user);
    }
  }

  return (
    <div className="flex flex-1">
      <UsersLayout users={allUsers} selectedUser={selectedUser} onAction={userActionHandler} />
    </div>
  );
}
